/** 登录页表单类型 */
export const FormType = {
  PASSWORD_LOGIN: 0,
  REGISTE: 1,
  WECHAT_BIND: 2,
};

/** 动态验证码类型 */
export const DynamicCodeType = {
  EMPTY: 0,
  REGISTER: 1,
  LOGIN: 2,
  BIND: 6,
};
